module.exports = __webpack_public_path__ + "static/media/prorroga-posgrado.f083ed43.docx";